import { CARD_ELEMENT_TYPE } from '../../../../../../../services/cards/constants';
import {
  isCardElementEditable,
  isFullFrame,
} from '../../../../../../../services/cards/components/AccountCard/helpers';
import { CONTROL_SECTION as PHOTO_TYPE } from '../../../../helpers';

/**
 * Determines whether an element is the Card's foreground.
 * We're using a photo element by default.
 *
 * @param {Object} element The element.
 * @returns {boolean}
 */
export const isElementCardForeground = element => {
  if (!element) {
    return false;
  }

  const { cardElement, cardElementConfiguration } = element;

  if (cardElementConfiguration?.photo_type === PHOTO_TYPE.FOREGROUND) {
    return true;
  }

  const isPhoto = cardElement.type === CARD_ELEMENT_TYPE.PHOTO;
  const { frame, z_index: zIndex } = cardElement;
  const isFullView = isFullFrame(frame);

  const isEditable = isCardElementEditable(element);

  // 999 Would be previous (pre-changes) foreground index, left here for backwards compat.
  return isPhoto && isFullView && !isEditable && zIndex === 999;
};
